import { ProcessStatusCode } from "@/types/code.types";

export type PublicationListPressInfoFilterKey =
  | "allInfo"
  | "publicationIdInfo"
  | "doiInfo"
  | "titleInfo"
  | "affiliationInfo";

export interface PublicationListPressInfoFilterType {
  key: PublicationListPressInfoFilterKey;
  name: string;
  isAllInfo: boolean;
  code?: ProcessStatusCode;
}

export const PUBLICATION_LIST_INFO_FILTER: PublicationListPressInfoFilterType[] =
  [
    {
      key: "allInfo",
      name: "All Info",
      isAllInfo: true,
    },
    {
      key: "publicationIdInfo",
      name: "Publication ID",
      isAllInfo: false,
    },
    {
      key: "doiInfo",
      name: "DOI",
      isAllInfo: false,
    },
    {
      key: "titleInfo",
      name: "Publication Title",
      isAllInfo: false,
    },
    {
      key: "affiliationInfo",
      name: "Affiliation",
      isAllInfo: false,
    },
  ];

export const PUBLICATION_LIST_PRESS_INFO_FILTER_KEY = [
  "allInfo",
  "publicationIdInfo",
  "doiInfo",
  "titleInfo",
  "affiliationInfo",
] as const;
